<section class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0">
<div class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border" [ngClass]="{
            'shadow-lg border border-zinc-950/10 dark:border-white/10': source !== 'modal'
          }">
    <form [formGroup]="addCancelReasonForm" (ngSubmit)="onSave()">
        <h1 *ngIf="source !== 'modal'" class="heading">
            {{cancelReasonId ? 'Edit' : 'Add'}}
        </h1>
        <hr *ngIf="source !== 'modal'" class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        
        <section class="grid gap-4 md:grid-cols-2">

            <!-- name -->
            <div class="space-y-1">
                <label class="subheading">
                    Title <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input type="text" formControlName="title" />
                    </div>
                </div>
                <div *ngIf="form.title.errors && submitted">
                    <div *ngIf="form.title.errors.required" class="error">
                        <p class="mt-2 text-red-600 text-xs">
                            Title is required
                        </p>
                    </div>
                </div>
            </div>
            <!-- status -->
            <div class="space-y-1">
                <label class="subheading">
                    Status
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <select formControlName="isActive">
                            <option [value]="true">Active</option>
                            <option [value]="false">Inactive</option>
                          </select>
                    </div>
                </div>
                <div *ngIf="form.isActive.errors && submitted">
                    <div *ngIf="form.isActive.errors.required" class="error">
                        <p class="mt-2 text-red-600 text-xs">
                            Status is required
                        </p>
                    </div>
                </div>
            </div>
            
            <!-- Description -->
            <div class="space-y-1">
                <label class="subheading">
                    Description <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <textarea type="text" formControlName="description"></textarea>
                    </div>
                </div>
                <div *ngIf="form.description.errors && submitted">
                    <div *ngIf="form.description.errors.required" class="error">
                        <p class="mt-2 text-red-600 text-xs">
                            Description is required
                        </p>
                    </div>
                </div>
            </div>
            <div class="space-y-1">
                    <label class="subheading">Platform
                        <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <!-- Using items input with multiple selection -->
                        <ng-select [ngModelOptions]="{standalone: true}" [items]="types" bindLabel="label"
                            bindValue="value" [(ngModel)]="selecteType" [multiple]="true" [clearable]="false"
                            [closeOnSelect]="false" placeholder="Select Platform" [searchable]="true">
                        </ng-select>
                        <!-- Validation Message -->
                        <div *ngIf="submitted && selecteType?.length === 0">
                            <p *ngIf="form.audience?.errors?.required" class="pt-1 text-red-600 text-xs">
                                Platform is required
                            </p>
                        </div>
                    </div>
                </div>

        </section>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <div class="flex gap-4">
              <!-- Billable -->

            <div class="space-y-1 flex items-center justify-center border border-dashed border-zinc-950/10 dark:border-white/10 p-1.5 rounded-lg gap-2.5">
                <label class="subheading">Billable</label>
                <div class="flex items-center mt-2">
                    <label
                        class="relative inline-flex h-6 w-12 flex-shrink-0 cursor-pointer rounded-full border-gray-300 bg-gray-200 text-sm-dark transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                        <input type="checkbox" formControlName="isBillable" class="sr-only peer" />
                        <span
                            class="absolute left-0 top-0 h-6 w-12 rounded-full transition-colors duration-200 ease-in-out bg-gray-300 peer-checked:bg-green-500"></span>
                        <span
                            class="absolute left-0 top-0 h-6 w-6 bg-white rounded-full shadow transform transition-transform duration-200 ease-in-out peer-checked:translate-x-6 flex items-center justify-center">
                            <svg *ngIf="!addCancelReasonForm.get('isBillable')?.value" class="h-3 w-3 text-red-500" fill="none"
                                viewBox="0 0 12 12">
                                <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <svg *ngIf="addCancelReasonForm.get('isBillable')?.value" xmlns="http://www.w3.org/2000/svg" fill="none"
                                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-3 w-3 text-white">
                                <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                            </svg>
                        </span>
                    </label>
                </div>
            </div>

            <!-- isNoShow -->
             <div class="space-y-1 flex items-center justify-center border border-dashed border-zinc-950/10 dark:border-white/10 p-1.5 rounded-lg gap-2.5">
                <label class="subheading">No Show</label>
                <div class="flex items-center mt-2">
                    <label
                        class="relative inline-flex h-6 w-12 flex-shrink-0 cursor-pointer rounded-full border-gray-300 bg-gray-200 text-sm-dark transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                        <input type="checkbox" formControlName="isNoShow" class="sr-only peer" />
                        <span
                            class="absolute left-0 top-0 h-6 w-12 rounded-full transition-colors duration-200 ease-in-out bg-gray-300 peer-checked:bg-green-500"></span>
                        <span
                            class="absolute left-0 top-0 h-6 w-6 bg-white rounded-full shadow transform transition-transform duration-200 ease-in-out peer-checked:translate-x-6 flex items-center justify-center">
                            <svg *ngIf="!addCancelReasonForm.get('isNoShow')?.value" class="h-3 w-3 text-red-500" fill="none"
                                viewBox="0 0 12 12">
                                <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <svg *ngIf="addCancelReasonForm.get('isNoShow')?.value" xmlns="http://www.w3.org/2000/svg" fill="none"
                                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-3 w-3 text-white">
                                <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                            </svg>
                        </span>
                    </label>
                </div>
            </div>
        </div>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

        <section class="flex justify-end gap-4">            
            <button type="submit" class="btn btn-secondary">
                {{cancelReasonId ? 'Update' : 'Create'}}
            </button>
        </section>
    </form>
</div>
</section>